import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import "firebase/firestore";
import "firebase/functions";

// Initialize Firebase
let config = {};

try {
  config = JSON.parse(process.env.REACT_APP_FIREBASE_CONFIG)
} catch (e) {
  console.error('Missing in .env: REACT_APP_FIREBASE_CONFIG')
}

firebase.initializeApp(config);
const auth = firebase.auth();

const googleAuthProvider = new firebase.auth.GoogleAuthProvider();

googleAuthProvider.setCustomParameters({  hd: 'buzzmetrics.com' });

const database = firebase.database();

const fireStore = firebase.firestore();

const functions = firebase.functions();


export {
  fireStore,
  database,
  auth,
  googleAuthProvider,
  functions,
  firebase,
};
